module.exports = __webpack_public_path__ + "static/img/02560_6.fcc2068.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02560_6.jpg
// module id = n7dt
// module chunks = 1